export default "__VITE_ASSET__bcf71589__"